/**
 * Apply Buy buttons block colors to Shopify dynamic checkout (Buy it now) after injection.
 */
(function () {
  'use strict';

  function applyBinColors(root) {
    if (!root) return;
    var bg = root.getAttribute('data-bin-bg');
    var text = root.getAttribute('data-bin-text');
    var border = root.getAttribute('data-bin-border');
    if (!bg && !text && !border) return;

    var selectors =
      '.shopify-payment-button__button--unbranded, .shopify-buy-it-now-button__button, .shopify-payment-button__button';
    root.querySelectorAll(selectors).forEach(function (btn) {
      if (bg) btn.style.setProperty('background-color', bg, 'important');
      if (text) btn.style.setProperty('color', text, 'important');
      if (border) btn.style.setProperty('border-color', border, 'important');
    });

    var mainId = root.getAttribute('data-section-id');
    if (mainId) {
      var sticky = document.getElementById('sticky-cart-' + mainId);
      if (sticky) {
        var sbg = sticky.getAttribute('data-bin-bg') || bg;
        var stext = sticky.getAttribute('data-bin-text') || text;
        var sborder = sticky.getAttribute('data-bin-border') || border;
        sticky.querySelectorAll(selectors).forEach(function (btn) {
          if (sbg) btn.style.setProperty('background-color', sbg, 'important');
          if (stext) btn.style.setProperty('color', stext, 'important');
          if (sborder) btn.style.setProperty('border-color', sborder, 'important');
        });
      }
    }
  }

  function initStickyBin(root) {
    var mainId = root.getAttribute('data-section-id');
    if (!mainId) return;
    var sticky = document.getElementById('sticky-cart-' + mainId);
    if (!sticky || sticky.dataset.rlBinColorsBound) return;
    if (!sticky.getAttribute('data-bin-bg') && !sticky.getAttribute('data-bin-text') && !sticky.getAttribute('data-bin-border')) return;
    sticky.dataset.rlBinColorsBound = '1';
    applyBinColors(sticky);
    if (typeof MutationObserver !== 'undefined') {
      var obs = new MutationObserver(function () {
        applyBinColors(sticky);
      });
      obs.observe(sticky, { childList: true, subtree: true });
    }
  }

  function initRoot(root) {
    if (!root || root.dataset.rlBinColorsBound) return;
    root.dataset.rlBinColorsBound = '1';
    applyBinColors(root);

    if (typeof MutationObserver !== 'undefined') {
      var obs = new MutationObserver(function () {
        applyBinColors(root);
      });
      obs.observe(root, { childList: true, subtree: true });
    }

    window.setTimeout(function () {
      applyBinColors(root);
    }, 120);
    window.setTimeout(function () {
      applyBinColors(root);
    }, 500);
    window.setTimeout(function () {
      applyBinColors(root);
    }, 1200);
  }

  function boot() {
    document.querySelectorAll('[data-buy-buttons-root]').forEach(initRoot);
    document.querySelectorAll('.product-sticky-cart[data-section-id]').forEach(function (sticky) {
      initStickyBin(sticky);
      if (typeof MutationObserver !== 'undefined') {
        var obs = new MutationObserver(function () {
          applyBinColors(sticky);
        });
        obs.observe(sticky, { childList: true, subtree: true });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
